import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { GroupEntity } from './group.entity';

@Index('client_group_group__id_fk', ['fkGroupId'], {})
@Index('client_group_pk', ['deletedDate', 'fkClientId', 'fkGroupId'], {
	unique: true,
})
@Entity('client_group')
export class ClientGroupEntity extends BaseEntity {
	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: '_fk_group__id', unsigned: true })
	public fkGroupId!: number;

	@ManyToOne(() => ClientEntity, (client) => client.clientGroups, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(() => GroupEntity, (group) => group.clientGroups, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_group__id', referencedColumnName: 'id' }])
	public fkGroup!: GroupEntity;
}
